module.exports = __webpack_public_path__ + "img/selected7-min.0d367ae6.png";